module.exports = __webpack_public_path__ + "static/media/daughter-sitting-on-mom-leg.67d9cccc.jpg";